// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleExportRunner = {
  id: "export-runner",
  mrn: "//iam.api.mondoo.app/roles/export-runner",
  title: "Export Runner",
  allowedActions,
} as const;

export type RoleExportRunner = typeof roleExportRunner;
